import { mapActions, mapGetters } from "vuex";
export default {
  name: "Navbar",
  computed: {
    ...mapGetters(["isLoggedIn"]),
    loggedIn: function() {
      return this.isLoggedIn;
    }
  },
  methods: {
    ...mapActions(["dispatchLogout"]),
    logout() {
      this.dispatchLogout();
      console.log("pushing router");
      this.$router.go("/");
    }
  }
};
